import { Fragment, Suspense, useEffect } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';

import { useBoundStore } from 'app/store';
import { useSaveServiceParams } from 'legacy/lib';

import { Body } from './ui';

const Redirect = () => {
  const navigate = useNavigate();
  const serviceParams = useBoundStore((store) => store['personalInfoAgree'].serviceParams);
  const setIsRedirected = useBoundStore((store) => store['personalInfoAgree'].setIsRedirected);

  useEffect(() => {
    setIsRedirected(true);
    if (serviceParams) navigate('/personalInfoAgree/main');
  }, [serviceParams]);

  return null;
};


const PersonalInfoAgreement = () => {
  const isRedirected = useBoundStore((store) => store['personalInfoAgree'].isRedirected);
  const serviceParams = useBoundStore((store) => store['personalInfoAgree'].serviceParams);
  useSaveServiceParams('personalInfoAgree', serviceParams);

  if (!isRedirected && !Object.keys(serviceParams).length > 0) {
    return (
      <div
        style={{
          display: 'flex',
          height: '100%',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          fontWeight: 500,
        }}
      >
        잘못된 접근 방식입니다 <br /> 찾으시는 페이지가 존재하지 않습니다
      </div>
    );
  }

  return (
    <Fragment>
      <h2 className='screen_out'>제3자 정보 동의</h2>
      <Routes>
        <Route path='/' element={<Redirect />}></Route>
        <Route
          path='/main'
          element={
            <Suspense>
              <Body />
            </Suspense>
          }
        ></Route>
      </Routes>
    </Fragment>
  );
};

export default PersonalInfoAgreement;
